import React, { useState, useEffect } from 'react';
import styles from './homepage.module.css';

const HomePage = () => {
  const [tasks, setTasks] = useState([]);
  const [newTask, setNewTask] = useState({ text: '', priority: 'Low', label: '', notes: '' });
  const [editingTask, setEditingTask] = useState(null);

  useEffect(() => {
    const fetchTasks = async () => {
      const response = await fetch('https://my-worker.example.workers.dev/tasks');
      const data = await response.json();
      setTasks(data);
    };
    fetchTasks();
  }, []);

  const handleChange = (e) => {
    setNewTask({ ...newTask, [e.target.name]: e.target.value });
  };

  const handleAddTask = async (e) => {
    e.preventDefault();
    if (newTask.text.trim()) {
      const response = await fetch('https://my-worker.example.workers.dev/tasks', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newTask),
      });
      const data = await response.json();
      setTasks([...tasks, data]);
      setNewTask({ text: '', priority: 'Low', label: '', notes: '' });
    }
  };

  const handleEditTask = async (e) => {
    e.preventDefault();
    if (newTask.text.trim()) {
      const response = await fetch(`https://my-worker.example.workers.dev/tasks/${editingTask.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newTask),
      });
      const data = await response.json();
      setTasks(tasks.map((task) => (task.id === editingTask.id ? data : task)));
      setNewTask({ text: '', priority: 'Low', label: '', notes: '' });
      setEditingTask(null);
    }
  };

  const handleDeleteTask = async (id) => {
    await fetch(`https://my-worker.example.workers.dev/tasks/${id}`, { method: 'DELETE' });
    setTasks(tasks.filter(task => task.id !== id));
  };

  const handleEditClick = (task) => {
    setEditingTask(task);
    setNewTask({ text: task.text, priority: task.priority, label: task.label, notes: task.notes });
  };

  return (
    <div className={styles.homecontainer}>
      <h1>Tasks</h1>
      <form onSubmit={editingTask ? handleEditTask : handleAddTask}>
        <input type="text" name="text" value={newTask.text} onChange={handleChange} placeholder="Task Name" className={styles.input} required />
        <select name="priority" value={newTask.priority} onChange={handleChange} className={styles.select}>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
        <input type="text" name="label" value={newTask.label} onChange={handleChange} placeholder="Label (optional)" className={styles.input} />
        <input type="text" name="notes" value={newTask.notes} onChange={handleChange} placeholder="Notes (optional)" className={styles.input} />
        <button type="submit" className={styles.button}>{editingTask ? 'Save Changes' : 'Add Task'}</button>
      </form>
      <div className={styles.tasklist}>
        {tasks.map((task) => (
          <div key={task.id} className={styles.task}>
            <div className={styles.taskinfo}>
              <p><strong>{task.text}</strong> ({task.priority})</p>
              {task.label && <span className={styles.label}>{task.label}</span>}
              {task.notes && <p className={styles.notes}>{task.notes}</p>}
            </div>
            <div className={styles.actions}>
              <button onClick={() => handleEditClick(task)} className={styles.editbutton}>Edit</button>
              <button onClick={() => handleDeleteTask(task.id)} className={styles.deletebutton}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
